import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {EaImportConfigDraftDto} from "../../../../../model/dto/entity/ea-import-config-draft.dto";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'ea-project-import-configs-tab',
    templateUrl: './ea-project-import-configs-tab.component.html',
    standalone: false
})
export class EaProjectImportConfigsTabComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;

    initialized: boolean;
    importConfigsWidget: WidgetData;
    selectedImportConfig: EaImportConfigDraftDto;

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }

        const filterCriteria = FilterCriteria.create('project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.importConfigsWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.import.configs.widget',
            'Import Configurations',
            'ea.EaImportConfigDraft',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'projectDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.importConfigsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    handleImportConfigSelect(event: any): void {
        if (event?.data) {
            this.selectedImportConfig = event.data;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier']) {
            this.refreshWidgets();
        }
    }

    ngOnDestroy(): void {
    }
}
